import {
  GET_EMPLOYEES,
  GET_EMPLOYEES_FOR_GROUP,
  GET_EMPLOYEE_CONSUMPTIONS,
  GET_EMPLOYEE_CREDIT_TRANSACTIONS,
  GET_EMPLOYEE_DETAILS,
  GET_EMPLOYEE_SECTION,
  GET_EMPLOYEE_STATUS,
  GET_UPLOAD_STATUS,
  REMOVE_EMPLOYEE_FROM_COMPANY,
  SET_UPLOAD_MSG,
  UPLOAD_EMPLOYEES,
  UPSERT_EMPLOYEE,
} from '../../actions/employee';
import { employeeUploadMsg } from '../../pages/common/components/constants';

const employeesReducer = (state = {}, action = {}) => {
  const {
    type = '',
    employeesData = {},
    employeeData = {},
    processId = '',
    employeeStatus = 1,
    uploadStatusData = {},
    employeeSection = {},
    groupEmployees = {},
    creditTransactions = {},
    removedEmployeeStatus = {},
    uploadMsg = employeeUploadMsg,
    ordersData = {},
  } = action;

  switch (type) {
    case UPSERT_EMPLOYEE.INITIATE:
      return {
        ...state,
      };
    case UPSERT_EMPLOYEE.SUCCESS:
      return {
        ...state,
      };
    case UPSERT_EMPLOYEE.FAILED:
      return {
        ...state,
      };
    case GET_EMPLOYEE_SECTION.INITIATE:
      return {
        ...state,
      };
    case GET_EMPLOYEE_SECTION.FAILED:
      return {
        ...state,
      };
    case GET_EMPLOYEE_SECTION.SUCCESS:
      return {
        ...state,
        ...employeeSection,
      };
    case GET_EMPLOYEES.INITIATE:
      return {
        ...state,
      };
    case GET_EMPLOYEES.SUCCESS:
      return {
        ...state,
        ...employeesData,
      };
    case GET_EMPLOYEES.FAILED:
      return {
        ...state,
      };
    case GET_EMPLOYEES_FOR_GROUP.INITIATE:
      return {
        ...state,
      };
    case GET_EMPLOYEES_FOR_GROUP.SUCCESS:
      return {
        ...state,
        ...groupEmployees,
      };
    case GET_EMPLOYEES_FOR_GROUP.FAILED:
      return {
        ...state,
      };
    case REMOVE_EMPLOYEE_FROM_COMPANY.INITIATE:
      return {
        ...state,
      };
    case REMOVE_EMPLOYEE_FROM_COMPANY.SUCCESS:
      return {
        ...state,
        removedEmployeeStatus,
      };
    case REMOVE_EMPLOYEE_FROM_COMPANY.FAILED:
      return {
        ...state,
      };
    case UPLOAD_EMPLOYEES.INITIATE:
    case UPLOAD_EMPLOYEES.FAILED:
      return {
        ...state,
      };
    case UPLOAD_EMPLOYEES.SUCCESS:
      return {
        ...state,
        processId,
      };
    case UPLOAD_EMPLOYEES.CLEAR:
      return {
        ...state,
        processId: '',
        uploadMsg: employeeUploadMsg,
        uploadStatusData: {},
      };
    case SET_UPLOAD_MSG:
      return {
        ...state,
        uploadMsg,
      };
    case GET_UPLOAD_STATUS.INITIATE:
    case GET_UPLOAD_STATUS.FAILED:
      return {
        ...state,
      };
    case GET_UPLOAD_STATUS.SUCCESS:
      return {
        ...state,
        uploadStatusData,
      };
    case GET_EMPLOYEE_DETAILS.INITIATE:
      return {
        ...state,
      };
    case GET_EMPLOYEE_DETAILS.SUCCESS: {
      return {
        ...state,
        employeeData,
      };
    }
    case GET_EMPLOYEE_DETAILS.FAILED:
      return {
        ...state,
      };

    case GET_EMPLOYEE_CREDIT_TRANSACTIONS.INITIATE:
      return {
        ...state,
      };
    case GET_EMPLOYEE_CREDIT_TRANSACTIONS.SUCCESS:
      return {
        ...state,
        creditTransactions,
      };
    case GET_EMPLOYEE_CREDIT_TRANSACTIONS.FAILED:
      return {
        ...state,
      };

    case GET_EMPLOYEE_STATUS.INITIATE:
      return {
        ...state,
      };
    case GET_EMPLOYEE_STATUS.SUCCESS: {
      const updatedState = state;
      updatedState.employeeData.status = employeeStatus;
      return {
        ...updatedState,
      };
    }
    case GET_EMPLOYEE_STATUS.FAILED:
      return {
        ...state,
      };
    case GET_EMPLOYEE_CONSUMPTIONS.INITIATE:
      return {
        ...state,
      };
    case GET_EMPLOYEE_CONSUMPTIONS.FAILED:
      return {
        ...state,
      };
    case GET_EMPLOYEE_CONSUMPTIONS.SUCCESS:
      return {
        ...state,
        ordersData,
      };
    default:
      return state;
  }
};

export default employeesReducer;
